import { useQuery } from '@tanstack/react-query';
import { Modal } from '@/components/dialogs/Modal';
import { LineChart } from '@/components/charts/LineChart';
import { clientProfitabilityApi } from '@/api/services/clientProfitability';
import type { ClientProfitabilityFilterInput } from '@/api/types/riskDashboard';

export function FirmPnlChartModal({
  open,
  onClose,
  filters,
}: {
  open: boolean;
  onClose: () => void;
  filters: ClientProfitabilityFilterInput;
}) {
  const q = useQuery({
    queryKey: ['cp-firm-chart', filters],
    queryFn: () => clientProfitabilityApi.getFirmNetPnlChartData(filters),
    enabled: open,
  });

  return (
    <Modal show={open} title="PNL History Chart" onClose={onClose} size="xl">
      <div className="firm-pnl-chart-wrap">
        {q.data && q.data.labels?.length ? (
          <LineChart
            height={400}
            labels={q.data.labels}
            series={q.data.datasets.map((d) => ({ label: d.label ?? '', data: d.data, color: d.borderColor ?? undefined }))}
          />
        ) : (
          <LineChart
            labels={[]}
            series={[]}
            height={400}
            emptyHint={q.isLoading ? 'Loading…' : 'No chart data for the selected range.'}
          />
        )}
      </div>
    </Modal>
  );
}
